module.exports = __webpack_public_path__ + "33aa5174e2c0e74cfb2bd6efc764272e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/trash-red.png
// module id = 227
// module chunks = 0